(() => {
  if (window.cfEwShopping || !document.documentElement.classList.contains('ew-calm-forms')) return;
  window.cfEwShopping = true;
  const quietForms = () => {
    document.querySelectorAll('[data-kl-scroll-locking-modal]').forEach(dialog => {
      const close = dialog.querySelector('button[aria-label="Close dialog"]');
      if (close && dialog.getAttribute('data-ew-dismissed') !== 'true') {
        dialog.setAttribute('data-ew-dismissed', 'true');
        close.click();
      }
    });
    document.querySelectorAll('[class*="kl-private-reset-css"] [role="button"], [class*="kl-private-reset-css"] button').forEach(button => {
      const text = (button.getAttribute('aria-label') || button.textContent || '').trim();
      if (/^(get|unlock)\s+10%\s+off!?$/i.test(text)) {
        const teaser = button.closest('[data-testid*="teaser" i]') || button;
        teaser.hidden = true;
        teaser.style.setProperty('display', 'none', 'important');
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; quietForms(); });
  };
  const boot = () => {
    document.body.classList.add('ew-shopping');
    quietForms();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})();
